import type { Product, Component, ProductDetail, DeploymentDetail } from './types';

const BASE =
  (import.meta.env.VITE_PLATFORM_URL as string | undefined) ??
  'https://arcforge-platform.raymond-ihh-tw.workers.dev';

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, init);
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status} ${path}: ${text.slice(0, 200)}`);
  }
  return res.json() as Promise<T>;
}

export const api = {
  listProducts: () => request<Product[]>('/api/products'),
  getProduct: (id: string) => request<ProductDetail>(`/api/products/${id}`),
  listComponents: (type?: 'core' | 'addon') =>
    request<Component[]>(`/api/components${type ? `?type=${type}` : ''}`),
  describeComponent: (id: string) => request<Component>(`/api/components/${id}`),
  getDeployment: (id: string) => request<DeploymentDetail>(`/api/deployments/${id}`),
};
